import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isScs: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.isScs = sessionStorage.getItem('brandName') == 'scs';
  }

}
